import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const backupTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Backup Template',
  key: 'backupTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['product', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      product: {
        label: 'Product',
        type: 'select',
        initial: 'all',
        options: [
          { label: 'ALL', value: 'all' },
          { label: 'XCIPIO', value: 'xcipio' },
          { label: 'Discovery', value: 'discovery' }
        ],
      },
      owner: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
    },
  },
};
